<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
              <span class="font-black text-6xl">Something to aim at</span>

              <div class="lesson-intro-image-wrapper">
               <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_2.svg"/>
             </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

            <div class="text-4xl">
                What do you truly want from life?
            </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>


           <div class="lg:w-1/4 w-1/2 mx-auto mb-4">
                <img src="@/assets/images/academy/aca_7.png"/>
            </div>

          <div class="">
            Our world is <span class="font-semibold">full of possibilities</span>, probably an infinite number of them, which makes choosing <span class="font-italic">"the right life path"</span> slightly difficult.
          </div>


        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

            <div class="text-lg pt-4">
                Thankfully here is a little secret:
            </div>

            <div class="text-4xl">
                There isn't a bad way to start.
            </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

            <div class="">
               No doubt you have at least a small idea of what you want.
               </div>

        <div class="mt-6">
                Either you have a <span class="font-semibold">long-term dream</span> that you want to fulfill for a long time

                </div>

       <div class="my-2 text-base">
                or maybe

                </div>

             <div class="">
                you just want to <span class="font-semibold">improve your life situation</span>, anyway, it's some form of dream.

                </div>

        </LessonTabContent>
      </tab-content>



      <tab-content title="">
        <LessonTabContent>

           <div class="">
              We often need a mentor, psychologist or coach to confirm our own long-term goals
              </div>

            <div class="text-4xl pt-4">
              ...and that's fine.
              </div>

        </LessonTabContent>


      </tab-content>

      <tab-content title="">
        <LessonTabContent>

         <div class="">
              But at the same time, you know the true essence.
            </div>

           <div class="w-1/2 mx-auto my-4">
                <img src="@/assets/images/academy/aca_9.png"/>
            </div>

         <div class="mt-4">
              It's just about taking a <span class="font-semibold">moment with yourself</span> , in peace and quiet, and asking yourself the questions you want to know the answer to, including those you're <span class="font-semibold">afraid to answer</span>.
            </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

            <div class="text-4xl">Ask yourself</div>
            <div class="mt-4">
              How you can spend your time well so it feels 
              important?

            </div>


            <div class="mt-2"></div>
              What do you want to improve about your life?
            </div>
        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

           <div class="text-4xl">
              What do you want?
            </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

            <div class="mt-4">Do you want to finish school?</div>

            <div class="mt-4">Do you want to launch a startup?</div>

            <div class="mt-4">Do you want to get rid of anxiety?</div>

            <div class="mt-4">Stop procrastinating?</div>

            </div>

        </LessonTabContent>
      </tab-content>


          <tab-content title="">
        <LessonTabContent>

            <div class="">
               Build a house?
            </div>

        </LessonTabContent>
      </tab-content>

          <tab-content title="">
        <LessonTabContent>

            <div class="">
               Save the world?
            </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

            <div class="text-4xl font-semibold">
              Forget perfectionism
            </div>

            <div class="mt-4">
              Your dreams, long-term goals, and plans are never going to be perfect anyway, they are never going to be 100% true, but <span class="font-semibold">they make a life-changing difference </span> versus not having them.
            </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>

          <div class="w-1/3 mx-auto my-6">
                <img src="@/assets/images/academy/aca_10.png"/>
            </div>

        </LessonTabContent>
      </tab-content>



      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>

            <div class="text-3xl">
                Create a dream that warms your hearth when you think about it
            </div>

            <div>
              <vs-button class="mt-4" color="#5222D0" size="large" @click="redirectToActionBoard">create a dream</vs-button>
            </div>
        </LessonTabContent>
      </tab-content>

    </form-wizard>
  </LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    FormWizard,
    LessonTabContent,
    TabContent
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    redirectToActionBoard () {
      const routeData = this.$router.resolve({ name: 'journey', query: { initWithDreamSidebarOpen: 'true'  }})
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
